<div class="betslip">
    @if (!isNavigationFromEditBet) {
        <bs-digital-balance-header [inColumn]="inColumn" />
    }
</div>
@if (!isPlatformError) {
    <div class="betslip-result-content">
        <bs-digital-result-header [viewModel]="resultHeaderViewModel" />
        @if (summaryViewModel) {
            <bs-digital-result-summary
                class="betslip-result-summary"
                [viewModel]="summaryViewModel"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [isTeaserBet]="isTeaserBet" />
        }
        <div class="betslip-result-slips-options">
            @if (resultConfiguration.canKeepPlacedBetsInBetslip()) {
                <bs-digital-result-keep-placed [keepPlaced]="state.keepPlacedBetsInBetslip" />
            }
            @if (!resultConfiguration.canKeepPlacedBetsInBetslip()) {
                <span class="betslip-succeeded-slip-datails">{{ this.messages.editBet.betDetails }}</span>
            }
            <bs-digital-result-slips-details-switcher [(isSlipsDetailsOpen)]="isSlipsDetailsOpen" />
        </div>
        @if (summaryViewModel) {
            <bs-digital-result-slips
                [succeededSlips]="succeededSlips"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [teasedPoints]="state.result.teasedPoints"
                [class.betslip-result-slips--open]="isSlipsDetailsOpen"
                [tokenPayoutSummaries]="summaryViewModel.tokenPayoutSummaries"
                [possibleWinningTitle]="summaryViewModel.possibleWinnings.title" />
        }
        <bs-digital-result-links
            [succeededSlips]="succeededSlips"
            [failedSlips]="failedSlips"
            [shouldShowQuickLinks]="showQuickLinks"
            [trackingInformation]="trackingInformation"
            [shouldShowShareMyBet]="!isTeaserBet" />
        @if (hasArcPostBetMessage$ | async) {
            <div class="arc-betslip-message">
                <ms-arc-message [profileData]="(profileDetails$ | async) ?? undefined" [featureLocation]="FeatureLocation.PostBetSlipMessage" />
            </div>
        }
        @if (showStakeChangeBanner) {
            <bs-digital-over-ask-stakechange-confirmation />
        }
        @if (showStakeSettingMsg) {
            <bs-digital-over-ask-maxstake-settings />
        }
        <bs-digital-result-failed [oddsDisplayFormat]="oddsDisplayFormat" />
    </div>
} @else {
    <div class="note"><i [ngClass]="'theme-error-i warning-color'"></i><span [innerHTML]="platformErrorMessage"></span></div>
    <bs-digital-result-links
        [succeededSlips]="succeededSlips"
        [shouldShowQuickLinks]="true"
        [trackingInformation]="trackingInformation"
        [shouldShowShareMyBet]="!isTeaserBet" />
}
@if (showResultActions) {
    <bs-digital-result-actions
        [inColumn]="inColumn"
        [IsMaxStakeNeverAccepted]="showStakeChangeBanner"
        [IsMaxStakePreviouslyAccepted]="showStakeSettingMsg"
        [isTeaserBet]="isTeaserBet" />
}
